module.exports = __webpack_public_path__ + "media/ndg3.d1db82cc.mp4";